import React from "react";

type GroupProps = {
  children: React.ReactNode;
  visible?: boolean;
};

export function Group({ children, visible = true }: GroupProps) {
  if (!visible) {
    return null;
  }

  return <>{children}</>;
}

export default Group;
